import React from 'react';

const Edit = (props: { className?: string; onClick?: () => void }) => {
    return (
        <svg
            className={props.className}
            onClick={props.onClick}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'>
            <g clip-path='url(#clip0_451_21210)'>
                <path
                    d='M9.16602 3.3335H3.33268C2.89065 3.3335 2.46673 3.50909 2.15417 3.82165C1.84161 4.13421 1.66602 4.55814 1.66602 5.00016V16.6668C1.66602 17.1089 1.84161 17.5328 2.15417 17.8453C2.46673 18.1579 2.89065 18.3335 3.33268 18.3335H14.9993C15.4414 18.3335 15.8653 18.1579 16.1779 17.8453C16.4904 17.5328 16.666 17.1089 16.666 16.6668V10.8335'
                    stroke='currentColor'
                    stroke-width='1.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M15.416 2.0832C15.7475 1.75168 16.1972 1.56543 16.666 1.56543C17.1349 1.56543 17.5845 1.75168 17.916 2.0832C18.2475 2.41472 18.4338 2.86436 18.4338 3.3332C18.4338 3.80204 18.2475 4.25168 17.916 4.5832L9.99935 12.4999L6.66602 13.3332L7.49935 9.99986L15.416 2.0832Z'
                    stroke='currentColor'
                    stroke-width='1.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_451_21210'>
                    <rect
                        width='20'
                        height='20'
                        fill='white'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Edit;
